<template>
  <van-popup v-model="show" get-container="#app" round @click-overlay="closePop">
    <div class="pop-outer">
      <div class="pop-header">
        <span style="margin-right: .3005rem;"></span>{{ findDate }}
        假期留宿处理
        <div class="close-btn" @click="closePop">
          <van-icon name="cross" />
        </div>
      </div>
      <div class="dispose-form">

        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            留宿开始时间：
          </div>
          <div class="form-content" @click="openDatePicker(1)">
            <div class="form-content_input">
              {{ batchLeaveDateInfo.startDate ? getDate(batchLeaveDateInfo.startDate) : '' }}
              {{ batchLeaveDateInfo.startTime ?
    batchLeaveDateInfo.startDateType == 1 && batchLeaveDateInfo.startTimeType ? batchLeaveDateInfo.startTime +
      ' ' + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][batchLeaveDateInfo.startTimeType] +
      `${batchLeaveDateInfo.startSelectTimeType == 'start' ? '开始' : '结束'}` : batchLeaveDateInfo.startTime : ''
              }}
            </div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="align-items: center;">
            留宿结束时间：
          </div>
          <div class="form-content" @click="openDatePicker(2)">
            <div class="form-content_input">
              {{ batchLeaveDateInfo.endDate ? getDate(batchLeaveDateInfo.endDate) : '' }}
              {{ batchLeaveDateInfo.endTime ? batchLeaveDateInfo.endDateType == 1 && batchLeaveDateInfo.endTimeType ?
    batchLeaveDateInfo.endTime + ' ' + ['', '早离寝', '午归寝', '午离寝', '晚归寝'][batchLeaveDateInfo.endTimeType] +
    `${batchLeaveDateInfo.endSelectTimeType == 'start' ? '开始' : '结束'}` : batchLeaveDateInfo.endTime : '' }}
            </div>
          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="padding-top: .3606rem;"">
            留宿考勤时段：
          </div>
          <div class=" form-content">
            <!-- 时段选择 -->
            <div v-for="item in timeTypeList" :key="item.timeType"
              :class="nowSelectAttendTimeType.includes(item.timeType) ? 'content_timetype content_timetype_active' : 'content_timetype'"
              @click="handleSelectTimeType(item)" class="content_timetype">
              {{ item.timeName }}
            </div>

          </div>
        </div>
        <div class="dispose-form-item">
          <div class="form-label" style="letter-spacing: .4207rem;padding-right: 0;padding-top: .3606rem;">
            留宿原因：
          </div>
          <div class="form-content">
            <van-field v-model="reason" rows="1" :autosize="{ minHeight: 100 }" type="textarea"
              class="aj-textarea-input" maxlength="150" />
          </div>
        </div>
      </div>
      <div class="pop-button">
        <div class="pop-button-cancel" @click="closePop">取消</div>
        <div class="pop-button-confirm" @click="batchAddStay">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import filterRadio from './batchFilterRadio.vue';
import moment from 'moment';
export default {
  components: { filterRadio },
  props: {
    batchLeaveDateInfo: {
      type: Object,
      default: {}
    },
    leaveMatters: {
      type: String,
      default: ''
    },
    selectFloor: {
      type: String,
      default: ''
    },
    stayType: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      // 请假原因
      reason: null,
      // 请假类型
      leaveType: 0,
      // 请假类型列表
      columns: ['事假', '病假', '工伤假', '婚假', '丧假', '产假', '探亲假', '公假', '年休假'],
      // 请假弹窗选择
      show: false,
      // 考勤时段手动选中
      nowSelectAttendTimeType: [4],
      // 当前日期
      findDate: '',


      // 选中的所有学生
      personList: [],

      // 所有的考勤时段
      timeTypeList: [],
    };
  },
  computed: {

  },
  watch: {
    show(newVal, oldVal) {
      if (newVal) {
        this.getTimeTypeByDormId()
      }
    }
  },
  methods: {
    open(data) {
      this.show = true;
      this.personList = data.nowSelectPersonList
      this.findDate = data.findDate

      console.log('this.findDate', this.findDate)
    },
    openDatePicker(type) {
      this.$emit('openLeaveDate', type);
    },

    // 获取当前选中的人员的所有的考勤时段
    getTimeTypeByDormId() {
      if (this.selectFloor) {
        this.$https.findDormTimeIntervalData({
          dormId: this.selectFloor,
        }).then(res => {
          let arr = []
          res.data.forEach(item => {
            item.timeName = ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item.timeType]
            if (arr.length == 0) {
              arr.push(item)
            } else {
              if (arr.find(x => x.timeType == item.timeType)) {
                // 筛选最早的时段当做全校的默认时段
              } else {
                if (item.timeType == 4) {
                  arr.unshift(item)
                } else {
                  arr.push(item)
                }
              }
            }
          })
          this.timeTypeList = arr
        })
      } else {
        this.$https.findDormTimeIntervalData({}).then(res => {
          let arr = []
          res.data.forEach(item => {
            item.timeName = ['', '早离寝', '午归寝', '午离寝', '晚归寝'][item.timeType]
            if (arr.length == 0) {
              arr.push(item)
            } else {
              if (arr.find(x => x.timeType == item.timeType)) {
                // 筛选最早的时段当做全校的默认时段
              } else {
                if (item.timeType == 4) {
                  arr.unshift(item)
                } else {
                  arr.push(item)
                }
              }
            }
          })
          this.timeTypeList = arr

        })
      }
    },

    // 点击选择考勤时段
    handleSelectTimeType(data) {
      if (data.timeType == 4) {
        return
      } else {
        if (this.nowSelectAttendTimeType.includes(data.timeType)) { // 判断有没有
          this.nowSelectAttendTimeType = this.nowSelectAttendTimeType.filter(x => x != data.timeType)
        } else {
          this.nowSelectAttendTimeType.push(data.timeType)
        }
      }
    },



    closePop() {
      this.show = false;
      this.$emit('close');
    },
    // 批量添加留宿
    batchAddStay() {
      let _this = this;
      if (!this.batchLeaveDateInfo.startDate || !this.batchLeaveDateInfo.startTime) { // 监测开始时间选择
        this.$toast({ getContainer: '#app', message: '请选择留宿开始时间' })
        return
      }

      if (!this.batchLeaveDateInfo.endDate || !this.batchLeaveDateInfo.endTime) { // 监测结束时间
        this.$toast({ getContainer: '#app', message: '请选择留宿结束时间' })
        return
      }
      // 判断请假时间的先后顺序
      if (moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').isSame(moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm'), 'minute')) {

        this.$toast({ getContainer: '#app', message: '结束时间不能和开始时间相同' })
        return
      }

      if (moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').isBefore(moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm'), 'minute')) {

        this.$toast({ getContainer: '#app', message: '结束时间不能在开始时间之前' })

        return
      }
      // 请求参数
      let params = {
        auditId: JSON.parse(localStorage.getItem('userInfo')).id,
        accommodateBeginTime: moment(`${this.batchLeaveDateInfo.startDate} ${this.batchLeaveDateInfo.startTime}`, 'YYYY年MM月DD日 HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        accommodateEndTime: moment(`${this.batchLeaveDateInfo.endDate} ${this.batchLeaveDateInfo.endTime}`, 'YYYY年MM月DD日 HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        accommodateIds: this.personList.map(x => x.userId),
        attendanceTimeType: this.nowSelectAttendTimeType.join(','),
        remark: this.reason,
        schoolId: this.$store.state.schoolId,
        userId: this.$store.state.userId
      }
      const loading = this.$toast.loading({
        duration: 0,
        message: '假期留宿处理中',
        forbidClick: true,
        getContainer: '#app'
      });

      if (this.stayType == 1) { //  宿管补签
        this.$https.teacherAddDormAccommodate(params).then(res => {
          if (res.code == 200) {
            loading.clear();
            _this.$toast({
              type: 'success',
              overlay: true,
              message: '成功',
              duration: 1500
            });

            setTimeout(() => {
              this.show = false
              this.$emit('confirm', 'refresh')
            }, 2000);
          } else {
            loading.clear();
            _this.$toast('留宿失败');
          }
        })
      } else if (this.stayType == 2) { // 班主任留宿
        this.$https.teacherAuthDormAccommodate(params).then(res => {
          if (res.code == 200) {
            loading.clear();
            _this.$toast({
              type: 'success',
              overlay: true,
              message: '成功',
              duration: 1500
            });

            setTimeout(() => {
              this.show = false
              this.$emit('confirm', 'refresh')
            }, 2000);
          } else {
            loading.clear();
            _this.$toast('留宿失败');
          }
        })
      }

    },
    // 转换时间格式
    getDate(date) {
      return moment(date, 'YYYY年MM月DD日').format('YY-MM-DD')
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');

.pop-outer {
  color: #333;
  padding: 0 1rem;
  padding-bottom: 2rem;
  width: 90vw;
  position: relative;
  font-size: 0.875rem;
  background: url('./popinfo-bg.png');
  background-size: 100% 100%;

  .pop-header {
    padding: 1rem 0 1.125rem 0;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: bold;

    .close-btn {
      position: absolute;
      color: #999999;
      right: -0.5rem;
      top: 1rem;
      font-size: 1rem;
    }
  }

  .pop-button {
    margin-top: 1rem;
    display: flex;
    justify-content: space-around;

    &>div {
      padding: 0.5rem 2rem;
      border-radius: 2rem;
    }

    .pop-button-cancel {
      background-color: #e0e8f6;
    }

    .pop-button-confirm {
      background-color: #1989fa;
      color: #fff;
    }
  }
}

.dispose-form-item {
  display: flex;

  &+& {
    margin-top: .875rem;
  }

  .form-label {
    text-align: right;
    display: flex;
    // padding-right: 0.5rem;
    padding-top: 0.1rem;
    color: #666666ff;
  }

  .form-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    // 请假类型
    .form-content_type {
      height: 1.875rem;
      line-height: 1.875rem;
      padding: 0 1.0625rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .875rem;
      color: #666666;
      border-radius: .9375rem;
      background: #F4F5F9;
      margin-right: .4375rem;
    }

    .form-content_type_active {
      color: #fff;
      background: #3775FF;
    }

    // 输入框
    .form-content_input {
      flex: 1;
      height: 2.25rem;
      border-radius: .25rem;
      line-height: 2.25rem;
      padding: 0 .625rem;
      background-color: #F4F5F9;

      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .875rem;
      color: #333333;
      text-align: left;
    }

    .content_timetype {
      padding: .3005rem .601rem;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: .8413rem;
      color: #666;
      line-height: 1.1418rem;
      text-align: center;
      font-style: normal;
      background: #F4F5F9;
      border-radius: .9615rem;
      margin-right: .1803rem;
    }

    .content_timetype:nth-child(4n) {
      margin-top: .601rem;
    }

    .content_timetype_active {
      color: #FFFFFF;
      background: #3775FF;
    }







  }
}

::v-deep.aj-radio-circle {

  // background-color: red;
  .van-radio {
    margin-bottom: 0.5rem;

    .van-radio__icon {
      display: flex;
      align-items: center;

      .van-icon {
        background-color: #fff;
        height: 0.8em;
        width: 0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .van-radio__icon.van-radio__icon--checked {
      .van-icon {
        &::before {
          display: none;
        }

        &::after {
          display: block;
          content: '';
          width: 50%;
          height: 50%;
          background-color: #1989fa;
          border-radius: 100%;
        }
      }
    }
  }
}

::v-deep.aj-textarea-input {
  // border: 1px solid #ccc;

  &.van-cell {
    padding: 0.25rem 0.5rem;
    background: #F4F5F9;
  }
}
</style>
